import { ButtonClose } from "@/components/ui";
import { Oferta } from "@/landingPage/types/landingSections";

interface Props {
  oferta: Oferta;
  updateOferta: (
    id: string,
    field: keyof Oferta,
    value: string | number,
  ) => void;
  updateOfertas: (ofertas: Oferta[]) => void;
  handleRemoveOferta: (id: string) => void;
  ofertas: Oferta[];
}

export default function CardGrande({
  oferta,
  updateOferta,
  updateOfertas,
  handleRemoveOferta,
  ofertas,
}: Props) {
  const imagen = oferta.imagenes?.[0] ?? "/img/logo/LogoLinkServs.png";

  return (
    <div className="rounded-2xl border border-white/10 bg-zinc-900/80 p-4">
      <div className="flex flex-col sm:flex-row gap-4">
        {/* IMAGEN */}
        <div className="relative w-full sm:w-[140px] h-48 sm:h-auto shrink-0">
          <img src={imagen} className="w-full h-full object-cover rounded-xl" />

          <label className="absolute bottom-2 right-2 bg-black/70 text-white text-[10px] px-2 py-1 rounded cursor-pointer hover:bg-black">
            Cambiar
            <input
              type="file"
              accept="image/*"
              className="hidden"
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (!file) return;

                updateOfertas(
                  ofertas.map((o) =>
                    o.id === oferta.id
                      ? {
                          ...o,
                          imagenes: [...o.imagenes, URL.createObjectURL(file)],
                          _pendingFile: file,
                        }
                      : o,
                  ),
                );
              }}
            />
          </label>
        </div>

        {/* CONTENIDO */}
        <div className="flex-1 space-y-2 min-w-0 text-white">
          <input
            value={oferta.titulo ?? ""}
            placeholder="Título"
            onChange={(e) => updateOferta(oferta.id!, "titulo", e.target.value)}
            className="w-full rounded-lg bg-zinc-950 border border-white/10 px-3 py-2 text-sm"
          />

          <textarea
            value={oferta.descripcion ?? ""}
            placeholder="Descripción"
            onChange={(e) =>
              updateOferta(oferta.id!, "descripcion", e.target.value)
            }
            className="w-full h-20 resize-none rounded-lg bg-zinc-950 border border-white/10 px-3 py-2 text-sm"
          />

          <div className="flex flex-wrap sm:flex-nowrap items-center gap-2">
            <div className="relative flex-1 min-w-[120px]">
              <input
                type="number"
                value={oferta.precio || ""}
                placeholder="Precio"
                onChange={(e) =>
                  updateOferta(
                    oferta.id!,
                    "precio",
                    e.target.value === "" ? 0 : Number(e.target.value),
                  )
                }
                className="w-full rounded-lg bg-zinc-950 border border-white/10 px-3 pr-8 py-2 text-sm"
              />

              <span className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-400 pointer-events-none">
                €
              </span>
            </div>

            <div className="shrink-0">
              <ButtonClose onClick={() => handleRemoveOferta(oferta.id!)} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
